// Which deployed environment this build belongs to, for the sidebar indicator.
//
// Driven by the Vite build mode: CI runs `vite build --mode staging|demo|production`
// (see package.json `build:*` scripts), so `import.meta.env.MODE` is fixed at build
// time. Production and local dev (`development`) get no indicator.
//
// To preview locally: `pnpm dev --mode staging` (note: this also loads
// `.env.staging`, which points the API at staging).

export type NonProductionEnvironment = 'staging' | 'demo';

export interface EnvironmentIndicator {
  environment: NonProductionEnvironment;
  /** Shown under the wordmark when the sidebar is expanded. */
  label: string;
  /** Shown under the menu icon when the sidebar is collapsed (40px wide). */
  shortLabel: string;
}

const INDICATORS: Record<NonProductionEnvironment, EnvironmentIndicator> = {
  staging: { environment: 'staging', label: 'Staging environment', shortLabel: 'STG' },
  demo: { environment: 'demo', label: 'Demo environment', shortLabel: 'DEMO' },
};

const isNonProduction = (mode: string): mode is NonProductionEnvironment =>
  Object.prototype.hasOwnProperty.call(INDICATORS, mode);

export const getEnvironmentIndicator = (
  mode: string = import.meta.env.MODE,
): EnvironmentIndicator | null => (isNonProduction(mode) ? INDICATORS[mode] : null);
